module.exports = __webpack_public_path__ + "static/img/MS.8575be2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/states/MS.jpg
// module id = qPO2
// module chunks = 0